import React, { useEffect } from "react";

export interface PopoverOpenSyncProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Syncs Headless UI Popover `open` to external state via useEffect,
 * avoiding setState during the Popover render callback.
 */
export const PopoverOpenSync: React.FC<PopoverOpenSyncProps> = ({
  open,
  onOpenChange,
}) => {
  useEffect(() => {
    onOpenChange(open);
  }, [open, onOpenChange]);

  return null;
};
